import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles('pe-onboarding', ({ palette, typography, breakpoints }) => ({
  form: {
    textAlign: 'center',
    marginBottom: '2em',
  },

  requiredText: {
    width: '100%',
    position: 'relative',
    textAlign: 'right',
    color: palette.grey.A200,
    fontSize: '0.625rem',
    paddingRight: '0.525em',
    marginBottom: '0.3em',
  },

  infoText: {
    width: '100%',
    color: palette.grey[500],
    fontSize: '0.75rem',
    marginBottom: '0.5em',
  },

  mainTitle: {
    fontWeight: typography.fontWeightSemiBold,
    marginBottom: '0.4em',
    letterSpacing: '0.011em',
    fontSize: 'clamp(1.5rem, 3.1vh, 2.25rem) !important',
  },

  mainDesc: {
    letterSpacing: '0.011em',
    marginBottom: 'clamp(10px, 1.6vh, 1.5em)',
  },

  onboardingIntro: {
    '& .MuiStepper-root': {
      paddingBottom: 'clamp(2px, 0.4vh, 1.7em)',
    },
  },

  passwordContainer: {
    position: 'relative',
  },

  password: {
    position: 'relative',
    background: palette.common.white,
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },

  fakeUsername: {
    position: 'absolute',
    left: '50%',
    top: '40%',
    transform: 'translate(-50%, -50%)',
    borderColor: palette.common.white,
  },

  icon: {
    fontSize: '3rem',
    color: palette.grey.A200,
    marginTop: '0.8em',
    marginBottom: '1em',
  },

  iconValidation: {
    fontSize: '0.75rem',
    marginRight: '0.5rem',
    display: 'flex',
    alignItems: 'center',
  },

  passwordRules: {
    marginTop: 'clamp(0px, 0.1vh, 0.5rem)',
    marginBottom: 'clamp(6px, 1.2vh, 2rem)',
  },

  passwordInfo: {
    marginBottom: '0.25rem',
    fontWeight: 600,
    lineHeight: 1.5,
    display: 'flex',
  },

  passwordRule: {
    color: palette.grey[500],
    display: 'flex',
    alignItems: 'center',
  },

  passwordSuccess: {
    composes: '$passwordRule',
    color: palette.success.main,
    fontWeight: 600,
  },

  passwordError: {
    composes: '$passwordRule',
    color: palette.error.main,
    fontWeight: 600,
  },

  tooltip: {
    fontSize: '0.75rem',
    color: palette.grey[500],
    margin: '0.25em 0 0 0.5em',
    display: 'flex',
    alignItems: 'center',
  },

  containerStep1: {
    [breakpoints.up('md')]: {
      height: '686px',
    },
  },

  button: {
    position: 'sticky',
    bottom: '6px',
  },
}));

export default useStyles;
